import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=35674931"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"
import style0 from "./modal.vue?vue&type=style&index=0&id=35674931&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./modal.vue?vue&type=custom&index=0&blockType=modal&v-if=showModal&v-on%3Aclose=showModal%20%3D%20false&size=small"
if (typeof block0 === 'function') block0(component)

export default component.exports